
import React, { useState } from 'react'
import SwitchSelector from 'react-switch-selector'
import _ from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'

import UpdateVisibilityModal from '../visibility_modal'

import showToastNotification from '../../../widgets/toastify'
import { ApiHelper } from '../../../../helpers/apihelper'
import * as Constants from '../../../../helpers/constants'
import { SWITCH_OPTIONS, SOCIAL_ICONS } from '../../helpers/constants'
import ClipboardCopy from '../../../widgets/clipboard_copy'


const ProfileCard = ({ profile, client }) => {
  const [showModal, setShowModal] = useState(false)
  const [visibility, setVisibility] = useState({
    current: profile.visibility,
    previous: null
  })
  const [isLoading, setIsLoading] = useState(false)

  const handleToggleChange = (val) => {
    setVisibility((prevState) => ({
      current: val,
      previous: prevState.current
    }))
    setShowModal(true)
  }

  const handleVisibilityUpdate = (reason) => {
    setIsLoading(true)
    let requestBody = {
      filter: { profile_id: profile.id },
      update: { visibility: visibility.current },
      reason: reason,
    }

    let body = _.pick(requestBody, ApiHelper(client, 'UPDATE_PROSPECT_PERSON_VISIBILITY').API_BODY)

    ApiHelper(client, 'UPDATE_PROSPECT_PERSON_VISIBILITY')
      .API(client, body)
      .then((response) => {

        if (response.status === Constants.CO_API.SUCCESS) {
          if (_.isEmpty(response.data)) {
            showToastNotification({
              message: 'Profile visibility update failed',
              isSuccess: false,
            })
          } else {
            showToastNotification({
              message: 'Profile visibility updated successfully',
              isSuccess: true,
            })
          }
        } else {
          setVisibility((prevState) => ({
            ...prevState,
            current: prevState.previous
          }))
          showToastNotification({
            message: _.get(response, 'message', 'Something went wrong'),
            isSuccess: false,
          })
        }
      })
      .catch((error) => {
        setVisibility((prevState) => ({
          ...prevState,
          current: prevState.previous
        }))
        showToastNotification({
          message: _.get(error, 'message', 'Something went wrong'),
          isSuccess: false,
        })
      })
      .finally(() => {
        setShowModal(false)
        setIsLoading(false)
      })
  }

  const handleModalClose = () => {
    setShowModal(false)
    setVisibility((prevState) => ({
      ...prevState,
      current: prevState.previous
    }))
  }

  return (
    <div className="prospect-search-profile-card">
      <div className="prospect-search-profile-card-content">
        <div className="prospect-search-profile-card-info">
          <img
            className='prospect-search-profile-card-image'
            src={profile.picture_url}
            alt={profile.full_name}
          />
          <div>
            <h5>
              {profile.full_name}
            </h5>
            <div className="social-icons">
              <SocialsBox
                socials={profile.socials}
              />
            </div>
          </div>
        </div>
        <div className="prospect-search-profile-card-emails">
          {_.map(profile.emails, (emailObj, index) => (
            <div key={index}>
              <FontAwesomeIcon icon={faEnvelope} />
              <span>
                {emailObj.email_address}
              </span>
              <div className="prospect-search-copy-icon">
                <ClipboardCopy textToCopy={emailObj.email_address} />
              </div>
            </div>
          ))}
        </div>
        <div className="prospect-search-profile-card-actions">
          <div className={`switch-wrapper ${visibility.current}`}>
            <SwitchSelector
              name={profile.id}
              options={SWITCH_OPTIONS}
              onChange={handleToggleChange}
              forcedSelectedIndex={_.findIndex(SWITCH_OPTIONS, ['value', visibility.current])}
              wrapperBorderRadius={24}
              optionBorderRadius={24}
              fontSize={12}
              selectionIndicatorMargin={2}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
      <UpdateVisibilityModal
        showModal={showModal}
        onClose={handleModalClose}
        onUpdate={handleVisibilityUpdate}
        isLoading={isLoading}
        visibility={visibility.current}
        profile={profile}
      />
    </div>
  )
}

export default ProfileCard

const SocialsBox = ({ socials }) => {
  return (
    _.map(SOCIAL_ICONS.order, (ele, index) => {
      let socialObj = _.find(socials, (social) => { return _.toLower(social.name) === ele })
      if (!_.isEmpty(socialObj) && _.has(SOCIAL_ICONS.icons, _.toLower(socialObj.name))) {
        return (
          <a
            key={index}
            className='me-2'
            href={socialObj.url}
            target="_blank"
            rel="noreferrer noopener"
          >
            {SOCIAL_ICONS.icons[_.toLower(socialObj.name)].icon}
          </a>
        )
      }
    })
  )
}